export const formatDateForInput = (
  date: Date | string | null | undefined
): string => {
  if (!date) return "";

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) return "";

  return parsedDate.toISOString().split("T")[0];
};

export const formatDateToISOString = (
  date: Date | string | null | undefined
): string => {
  if (!date) return "";

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) return "";

  return parsedDate.toISOString();
};

/**
 * Formats a date to a string that can be parsed by ZonedDateTime.parse() in Java
 * Format: 2025-03-13T12:30:00+01:00
 */
export const formatDateForZonedDateTime = (
  date: Date | string | null | undefined
): string => {
  if (!date) return "";

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) return "";

  // Get timezone offset in minutes and convert to hours and minutes
  const tzOffset = parsedDate.getTimezoneOffset();
  const tzOffsetHours = Math.abs(Math.floor(tzOffset / 60));
  const tzOffsetMinutes = Math.abs(tzOffset % 60);
  const tzSign = tzOffset <= 0 ? "+" : "-";

  // Format the timezone offset as +HH:MM or -HH:MM
  const tzFormatted = `${tzSign}${tzOffsetHours
    .toString()
    .padStart(2, "0")}:${tzOffsetMinutes.toString().padStart(2, "0")}`;

  // Format the date in ISO format but replace the Z with the timezone offset
  const year = parsedDate.getFullYear();
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = parsedDate.getDate().toString().padStart(2, "0");
  const hours = parsedDate.getHours().toString().padStart(2, "0");
  const minutes = parsedDate.getMinutes().toString().padStart(2, "0");
  const seconds = parsedDate.getSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${tzFormatted}`;
};

export function parseToBackendDate(dateString: string): string {
  if (!dateString) {
    throw new Error("Invalid date: Empty string received.");
  }

  const parts = dateString.split("-");
  if (parts.length !== 3) {
    throw new Error("Invalid date format. Expected YYYY-MM-DD.");
  }

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  const date = new Date(Date.UTC(year, month, day, 0, 0, 0));

  if (
    date.getUTCDate() !== day ||
    date.getUTCMonth() !== month ||
    date.getUTCFullYear() !== year
  ) {
    throw new Error("Invalid date. Please provide a correct date.");
  }

  return date.toISOString();
}
